import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * @deprecated prefer direct calls to HttpClient methods
 */
@Injectable()
export class ApiGatewayService {
  constructor(private http: HttpClient) {}

  /**
   * @deprecated prefer HttpClient.get
   */
  get<T>(url: string, isTimer?: boolean, params?: any): Observable<any> {
    return this.http.get<any>(url);
  }

  /**
   * @deprecated prefer HttpClient.post
   */
  post(
    url: string,
    data?: any,
    isTimer?: boolean,
    params?: any,
    isBlob: boolean = false,
  ): Observable<any> {
    if (!data) {
      data = params;
      params = {};
    }

    // TODO: This could be handled in an HTTP Interceptor
    const options: any = { params };
    if (isBlob) {
      options.responseType = 'text';
    }
    return this.http.post(url, data, options);
  }

  /**
   * @deprecated prefer HttpClient.put
   */
  put(url: string, data?: any, params?: any): Observable<any> {
    if (!data) {
      data = params;
      params = {};
    }

    return this.http.put<any>(url, data, { params });
  }

  /**
   * @deprecated prefer HttpClient.patch
   */
  patch(url: string, data?: any, params?: any): Observable<any> {
    if (!data) {
      data = params;
      params = {};
    }

    return this.http.patch(url, data, { params });
  }

  /**
   * @deprecated prefer HttpClient.delete
   */
  delete(url: string, params?: any): Observable<any> {
    return this.http.delete(url, { params });
  }
}
